import { F0Box, F0Icon } from '@factorialco/f0-react'
import { Tooltip } from '@factorialco/f0-react/dist/experimental'
import { Link } from '@factorialco/f0-react/icons/app'

import { RawTag } from 'modules/job_catalog/components/customTags/RawTag'
import i18n from 'modules/core/lib/i18n'

export interface CompetencyTagProps {
  name: string
  isInherited: boolean
  inheritedFromName?: string
}

const CompetencyTag = ({ name, isInherited, inheritedFromName }: CompetencyTagProps) => {
  const inheritedIcon = (
    <F0Box display="flex" alignItems="center" justifyContent="center" width="sm" height="sm">
      <F0Icon icon={Link} size="sm" color="secondary" />
    </F0Box>
  )

  const right =
    isInherited && inheritedFromName ? (
      <Tooltip
        label={i18n.t('job_catalog.nodes.competency.inherited_from', {
          nodeName: inheritedFromName,
        })}
      >
        <F0Box
          aria-label={String(
            i18n.t('job_catalog.nodes.competency.inherited_from', {
              nodeName: inheritedFromName,
            })
          )}
          tabIndex={0}
        >
          {inheritedIcon}
        </F0Box>
      </Tooltip>
    ) : isInherited ? (
      inheritedIcon
    ) : undefined

  return <RawTag text={name} right={right} />
}

export default CompetencyTag
